import { Activity, PaginatedRequest, PaginatedResponse } from 'model';
import { createAsyncAction } from 'typesafe-actions';

export const getActivityBellItems = createAsyncAction(
  'activityBell/GET_ACTIVITY_BELL_ITEMS_REQUEST',
  'activityBell/GET_ACTIVITY_BELL_ITEMS_SUCCESS',
  'activityBell/GET_ACTIVITY_BELL_ITEMS_FAILURE',
)<
  PaginatedRequest & { pageSize?: number; search?: string },
  PaginatedResponse<Activity>,
  undefined
>();
